import { useEffect, useRef } from "react";

export default function HeroSection() {
  const floatRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let frame: number;
    let start: number | null = null;
    const animate = (ts: number) => {
      if (!start) start = ts;
      const elapsed = ts - start;
      if (floatRef.current) {
        floatRef.current.style.transform = `translateY(${Math.sin(elapsed / 1800) * 14}px)`;
      }
      frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ background: "linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 50%, #16213e 100%)" }}
    >
      {/* Background texture */}
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://public.readdy.ai/ai/img_res/e62f97eae2ab031f5988b9d0a7feb3c0.jpg"
          alt="background"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32 flex flex-col lg:flex-row items-center gap-16">
        {/* Left Content */}
        <div className="flex-1 flex flex-col gap-6">
          <span className="text-xs uppercase tracking-[0.25em] text-[#a0a8c0] font-medium">
            / iOS Development Studio
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-thin text-white leading-[1.15]">
            Modern Applications<br />
            <span className="font-light text-[#c8d0e8]">for iOS Platform</span>
          </h1>
          <p className="text-base md:text-lg text-[#8892a4] leading-relaxed max-w-lg font-light">
            BOBIS d.o.o. is a team of experts crafting premium iOS applications. Our products — including VPN and Cleaner — are engineered to enhance user experience and strengthen the security of mobile devices.
          </p>

          <div className="flex items-center gap-3 mt-4">
            <span className="text-sm text-[#8892a4] font-light">Expert iOS Development Team</span>
          </div>
        </div>

        {/* Right Visual */}
        <div ref={floatRef} className="flex-1 flex items-center justify-center">
          <div className="relative w-full max-w-md">
            {/* Phone mockup */}
            <div className="relative mx-auto w-64 md:w-72">
              <div
                className="rounded-[3rem] overflow-hidden border border-white/10"
                style={{
                  background: "linear-gradient(145deg, #1e2a3a, #0d1520)",
                  boxShadow: "0 40px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.05)",
                }}
              >
                <img
                  src="https://readdy.ai/api/search-image?query=iOS%20mobile%20app%20interface%20screenshot%20showing%20a%20clean%20VPN%20security%20dashboard%20with%20shield%20icon%2C%20connection%20status%2C%20dark%20mode%20UI%2C%20modern%20minimal%20design%2C%20teal%20and%20white%20accents%20on%20dark%20background%2C%20professional%20app%20design&width=400&height=700&seq=phone-screen-001&orientation=portrait"
                  alt="iOS App Interface"
                  className="w-full h-auto object-cover object-top"
                />
              </div>
              {/* Glow */}
              <div className="absolute -inset-8 rounded-full opacity-20 blur-3xl" style={{ background: "radial-gradient(circle, #4a90d9 0%, transparent 70%)" }} />
            </div>

            {/* Floating badge */}
            <div
              className="absolute -top-4 -right-4 md:right-0 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-4 py-3 flex items-center gap-2"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-shield-check-line text-emerald-400 text-xl" />
              </div>
              <div>
                <p className="text-white text-xs font-semibold">Secure &amp; Fast</p>
                <p className="text-[#8892a4] text-[10px]">iOS Optimized</p>
              </div>
            </div>


          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-50">
        <span className="text-[10px] uppercase tracking-widest text-white">Scroll</span>
        <div className="w-px h-8 bg-white/40 animate-pulse" />
      </div>
    </section>
  );
}
